import React, { useState, useEffect } from 'react';
import moment from 'moment';

import CommonSelect from './CommonSelect';
import './CommonSelect.css';

let Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

let min_age, months, i;

function getMonthsOptions(year, type, disableFuture, disablePastDates) {
  months = [];
  if (parseInt(year.value) == currentYear - 18 && type == 'dob') {
    for (i = 0; i <= Months.indexOf('December'); i++) {
      months.push(String(Months[i]));
    }
  } else {
    months = Months;
  }
  return months.map((each, index) => {
    let disable = false;
    let yearVal = parseInt(year.value),
      currYear = moment().year();
    try {
      if (disableFuture)
        disable =
          yearVal == currYear && index > new Date().getMonth() ? true : false;
      else if (disablePastDates) {
        disable =
          yearVal == currYear && index < new Date().getMonth() ? true : false;
      }
    } catch {
      disable = false;
    }
    return {
      label: each,
      value: String(index + 1),
      disable: disable
    };
  });
}

/**
 * Year logic
 */
let BASE_YEAR = 1950;
let yearOrder;
export let currentYear = parseInt(moment().format('YYYY'));
export const currentMonth = moment().format('MMMM');

function getYearOptions(type, disableFuture, disablePastDates) {
  let yearOptions = [];
  let year = BASE_YEAR;

  type == 'dob' ? (min_age = 18) : (min_age = 0);
  while (year <= currentYear - min_age) {
    let disableYear = false;
    if (disableFuture) disableFuture = year > moment().year() ? true : false;
    else if (disablePastDates)
      disableFuture = year < moment().year() ? true : false;
    yearOptions.push({
      value: String(year),
      label: year,
      disable: disableYear
    });
    year++;
  }
  if (yearOrder === 'desc') return yearOptions.reverse();
  return yearOptions;
}

function getDaysInMonth(year, month) {
  if (!year || !month) {
    return 0;
  }
  return moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
}

function getDaysOptions(
  noOfdays,
  type,
  year,
  month,
  disableFuture,
  disablePastDates
) {
  if (
    type == 'dob' &&
    currentMonth == Months[parseInt(month) - 1] &&
    year == parseInt(currentYear) - 18
  ) {
    noOfdays = moment().format('DD');
  }
  if (!noOfdays) return [];
  let daysOption = [];
  let dayCounter = 1;
  while (dayCounter <= noOfdays) {
    let disable = false;
    let currYear = moment().year(),
      currMonth = moment().format('MMMM'),
      isThisMonthAndYear = false;
    try {
      if (disableFuture || disablePastDates) {
        isThisMonthAndYear =
          year == currYear &&
          (month == new Date().getMonth() + 1 || month == currMonth);
        if (disableFuture)
          disable =
            isThisMonthAndYear && dayCounter > new Date().getDate()
              ? true
              : false;
        else if (disablePastDates)
          disable =
            isThisMonthAndYear && dayCounter < new Date().getDate()
              ? true
              : false;
      }
    } catch {
      disable = false;
    }
    daysOption.push({
      label: dayCounter,
      value: String(dayCounter),
      disable: disable
    });
    dayCounter++;
  }
  return daysOption;
}

function isDateValid({ month, year, date }) {
  const { value: currentDate } = date;
  const { value: currentYear } = year;
  const { value: currentMonth } = month;

  const daysInMonth = getDaysInMonth(currentYear, currentMonth);

  if (!isNaN(daysInMonth) && daysInMonth < currentDate) {
    return false;
  }
  return true;
}

function CommonDatePicker(props) {
  const {
    onChangeMonth,
    onChangeYear,
    onChangeDate,
    valueMonth,
    valueYear,
    valueDate,
    nameMonth = 'month',
    nameYear = 'year',
    nameDate = 'date',
    errorYear,
    errorMonth,
    errorDate,
    touchedYear,
    touchedMonth,
    touchedDate,
    onBlurMonth,
    onBlurYear,
    onBlurDate,
    errorMsg,
    yearOptionsOrder = 'desc', //anyOneOf['asce','desc']
    type = '',
    dropdownStyle = {},
    datePickerContainerstyle = {},
    styleHeight,
    maxYear,
    minYear,
    disableFuture = false,
    disablePastDates = false
  } = props;

  useEffect(() => {
    if (maxYear) {
      currentYear = maxYear;
    }
    if (minYear) {
      BASE_YEAR = parseInt(minYear);
    }
    yearOrder = yearOptionsOrder;
    return () => {
      BASE_YEAR = 1950;
      currentYear = moment().format('YYYY');
    };
  }, []);

  return (
    <div className="w-full h-10" style={styleHeight ? styleHeight : null}>
      <div
        className="h-full"
        style={{
          display: 'grid',
          gridTemplateColumns: '35% 25% 25%',
          justifyContent: 'space-between',
          ...datePickerContainerstyle
        }}
      >
        <CommonSelect 
          options={[
            {
              label: 'Month',
              value: ''
            },
            ...getMonthsOptions(
              valueYear,
              type,
              disableFuture,
              disablePastDates
            )
          ]}
          name={nameMonth}
          onChange={data => {
            const isValidDateStatement = isDateValid({
              month: data,
              year: valueYear,
              date: valueDate
            });
            onChangeMonth(data, isValidDateStatement);
          }}
          value={valueMonth}
          error={errorMonth}
          touched={touchedMonth}
          onBlur={onBlurMonth}
          dropdownStyle={dropdownStyle}
        />
        <CommonSelect 
          options={[
            {
              label: 'Date',
              value: ''
            },
            ...getDaysOptions(
              getDaysInMonth(valueYear.value, valueMonth.value),
              type,
              valueYear.value,
              valueMonth.value,
              disableFuture,
              disablePastDates
            )
          ]}
          name={nameDate}
          onChange={onChangeDate}
          onBlur={onBlurDate}
          value={valueDate}
          error={errorDate}
          touched={touchedDate}
          dropdownStyle={dropdownStyle}
        />
        <CommonSelect 
          options={[
            {
              label: 'Year',
              value: ''
            },
            ...getYearOptions(type, disableFuture, disablePastDates)
          ]}
          name={nameYear}
          onChange={data => {
            const isValidDateStatement = isDateValid({
              month: valueMonth,
              year: data,
              date: valueDate
            });
            // type=='dob'? handleDOBMonth(data.value) :null

            onChangeYear(data, isValidDateStatement);
          }}
          value={valueYear}
          error={errorYear}
          touched={touchedYear}
          onBlur={onBlurYear}
          dropdownStyle={dropdownStyle}
        />
      </div>
      {errorMsg && <div className="mt-1 text-xs text-red-300 ">{errorMsg}</div>}
    </div>
  );
}

export default CommonDatePicker;
